import React from "react";
import { Link } from "react-router-dom";
import { Glyphicon, Modal } from "react-bootstrap";
import _ from "lodash";

import NumberFormat from "react-number-format";
import Button from "../../../../../components/common/button/Button";
import Table from "../../../../../components/common/table/Table";
import { formatDateSmallWithoutTimezone } from "../../../../../utils/dates";
import { Mixpanel } from "../../../../../actions/mixpanel.actions";
import { INVOICE_INDEX_TABLE } from "../../../../../actions/invoice.actions";

import styles from "./Invoice.scss";
import iconPdf from "../../../../../assets/images/file-pdf.svg";
import template from "../../../../../assets/docs/invoice/Your-Name_Client-Name_Project-Title_Invoice-Date.docx";

class Invoice extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showRemoveModal: false,
      selectedInvoice: null
    };

    this.handleRemoveModalOpen = this.handleRemoveModalOpen.bind(this);
    this.handleRemoveModalClose = this.handleRemoveModalClose.bind(this);
  }

  handleRemoveModalOpen(invoice) {
    this.setState({ showRemoveModal: true, selectedInvoice: invoice });
  }

  handleRemoveModalClose() {
    this.setState({ showRemoveModal: false, selectedInvoice: null });
  }

  render() {
    const invoices = _.get(this.props, "invoices");

    const mappedInvoices =
      invoices.length > 0 &&
      invoices.map(invoice => {
        const project = _.get(invoice, "project");
        const status = _.get(invoice, "status");
        const company = _.get(project, "employer.profile.company");

        return {
          rowKey: invoice.id,
          data: [
            {
              displayText: this.getProjectDisplayText(project, company),
              orderByText: project.title
            },
            {
              displayText: this.getSubmissionDate(invoice),
              orderByText: invoice.created_at
            },
            {
              displayText: status.member,
              orderByText: status.id
            },
            {
              displayText: this.getAmountDisplayText(invoice.amount),
              orderByText: invoice.amount
            },
            {
              displayText: this.getActions(invoice)
            }
          ]
        };
      });

    return this.renderInvoices(mappedInvoices);
  }

  getSubmissionDate(invoice) {
    return (
      <div className={styles.rowHeaderSubtitle}>
        {formatDateSmallWithoutTimezone(invoice.created_at)}
      </div>
    );
  }

  getAmountDisplayText(amount) {
    return (
      <NumberFormat
        value={amount}
        displayType={"text"}
        thousandSeparator={true}
        prefix={"$"}
        decimalScale={2}
      />
    );
  }

  getStatusDisplayText(status) {
    return _.get(status, "member");
  }

  getProjectDisplayText(project, company) {
    return (
      <div className={styles.rowHeader}>
        <div>
          <Link
            to={`/member/company/${company.id}`}
            onClick={() =>
              Mixpanel.track("Member - Invoices - Project Company Name")
            }
          >
            {company.name}
          </Link>
        </div>
        <div className={styles.rowHeaderSubtitle}>
          <Link
            to={`/member/project/${project.id}/detail`}
            onClick={() =>
              Mixpanel.track("Member - Invoices - Project Job Title")
            }
          >
            {project.title}
          </Link>
        </div>
      </div>
    );
  }

  getActions(invoice) {
    let component = invoice.file && (
      <div className={styles.actionsContainer}>
        <a
          onClick={() => this.props.downloadInvoice(invoice.id)}
          className={styles.pdfIcon}
        >
          <img src={iconPdf} alt="PDF Icon" />
        </a>
        <a onClick={() => this.handleRemoveModalOpen(invoice)}>
          <Glyphicon glyph="trash" />
        </a>
      </div>
    );

    return component;
  }

  renderRemoveModal() {
    return (
      <Modal
        show={this.state.showRemoveModal}
        onHide={this.handleRemoveModalClose}
        dialogClassName={styles.modalContainer}
      >
        <Modal.Body className={styles.modalBody}>
          <div className={styles.title}>Are you sure?</div>
          <div className={styles.dividerLine} />
          <div className={styles.subtitle}>
            <p>
              Are you sure you want to delete invoice{" "}
              {_.get(this.state, "selectedInvoice.filename")}
            </p>
            <p>This can not be undone.</p>
          </div>

          <div className={styles.CTAContainer}>
            <Button
              isPrimary
              isSmall
              label="Yes"
              onClick={() => {
                this.props.removeInvoice(this.state.selectedInvoice.id);
                this.handleRemoveModalClose();
              }}
            />

            <Button
              isSecondary
              isSmall
              label="No"
              onClick={() => {
                this.handleRemoveModalClose();
              }}
            />
          </div>
        </Modal.Body>
      </Modal>
    );
  }

  renderInvoices(mappedInvoices) {
    const tableData = {
      headers: [
        {
          displayText: "PROJECT",
          id: "table-member-invoices-sort-project",
          track: "Table - Member Invoices - Sort By Project"
        },
        {
          displayText: "SUBMISSION DATE",
          id: "table-member-invoices-sort-submission-date",
          track: "Table - Member Invoices - Sort By Submission Date"
        },
        {
          displayText: "STATUS",
          id: "table-member-invoices-sort-status",
          track: "Table - Member Invoices - Sort By Status"
        },
        {
          displayText: "AMOUNT",
          id: "table-member-invoices-sort-amount",
          track: "Table - Member Invoices - Sort By Amount"
        },
        {
          displayText: "PDF",
          align: "right",
          sortDisabled: true
        }
      ],
      rows: mappedInvoices
    };

    const defaultSort = {
      headerIndex: 1,
      order: "desc"
    };

    return (
      <div className={styles.invoices}>
        <h2 className={styles.pageTitle}>Invoices</h2>
        <p className={styles.pageSubTitle}>
          Submit and track your invoices and payments here.
        </p>
        <p className={styles.pageSubTitle}>
          Remember, we issue checks on the 1st and 15th of every month after we
          receive payment from the client.
        </p>
        <p className={styles.pageSubTitle}>
          Ready to submit your invoice?{" "}
          <Link to="/member/invoice/create">
            Click here to add it to your Invoice History
          </Link>
        </p>
        <p className={styles.pageSubTitle}>
          Need an invoice template?{" "}
          <a
            href={template}
            download={`Your-Name_Client-Name_Project-Title_Invoice-Date.docx`}
          >
            Download ours
          </a>
        </p>

        <div className={styles.divider}>
          <div className={styles.top} />
          <div className={styles.bottom} />
        </div>

        <Table
          name={INVOICE_INDEX_TABLE}
          defaultSort={defaultSort}
          tableData={tableData}
        />

        {this.renderRemoveModal()}
      </div>
    );
  }
}

export default Invoice;



// WEBPACK FOOTER //
// ./src/routes/candidate/projects/invoice/components/Invoice.js